
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');

import Dropzone from 'dropzone';
window.Dropzone = Dropzone;

window.swal = require('sweetalert2');

window.axios = require('axios');

// Use shared axios configuration
import { setupAxios } from './config/axios';
setupAxios();

// Note: the listing create/edit address field (#google-autocomplete) is
// initialized by resources/views/partials/listing-address-picker.blade.php,
// which also lets the host pick a street/suburb/city precision. Do not bind
// another Autocomplete instance to it here - two instances on the same
// input fight over which "types" restriction wins.

$('[data-toggle="tooltip"]').tooltip()

// Import and make AvailabilityCalendar available globally
import AvailabilityCalendar from './components/AvailabilityCalendar';
window.AvailabilityCalendar = AvailabilityCalendar;

// Share listing functionality
function initShareButtons() {
    // Handle share button clicks (both icon-only and link variants)
    document.querySelectorAll('.btn-share-listing, .btn-share-listing-link').forEach(button => {
        button.addEventListener('click', async function(e) {
            e.preventDefault();
            const url = this.dataset.shareUrl;
            const title = this.dataset.shareTitle;
            
            // Try Web Share API first (mobile/supported browsers)
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: title,
                        text: `Check out this storage space: ${title}`,
                        url: url
                    });
                    return;
                } catch (err) {
                    // User cancelled or share failed, fall through to clipboard
                    if (err.name !== 'AbortError') {
                        console.log('Share failed, falling back to clipboard:', err);
                    } else {
                        return; // User cancelled, don't show clipboard message
                    }
                }
            }
            
            // Fallback to clipboard copy
            try {
                await navigator.clipboard.writeText(url);
                
                // Show success feedback
                if (typeof swal !== 'undefined') {
                    swal.fire({
                        icon: 'success',
                        title: 'Link Copied!',
                        text: 'The listing link has been copied to your clipboard.',
                        timer: 2000,
                        showConfirmButton: false,
                        toast: true,
                        position: 'top-end'
                    });
                } else {
                    alert('Link copied to clipboard!');
                }
            } catch (err) {
                console.error('Failed to copy to clipboard:', err);
                // Final fallback - show the URL in a prompt
                prompt('Copy this link:', url);
            }
        });
    });
}

// Initialize share buttons when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareButtons);
} else {
    initShareButtons();
}
